import type React from 'react';
import { useEffect, useState } from 'react';

import ShowtimesFinderFiltersPanel, { type ShowtimesFinderFilters } from './ShowtimesFinderFiltersPanel';

const FilterSheet: React.FC<{
    onClose: () => void;
    selectedDate: string;
    filters: ShowtimesFinderFilters;
    setFilters: (filters: ShowtimesFinderFilters) => void;
}> = ({ onClose, selectedDate, filters, setFilters }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Trigger animation after mount
        setTimeout(() => setIsVisible(true), 10);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        // Wait for animation to complete before calling onClose
        setTimeout(onClose, 300);
    };

    return (
        // z-index above Leaflet's internal panes/controls (which go up to 1000)
        <div className="absolute inset-0 z-[1100] rounded-[8px] overflow-hidden">
            {/* Backdrop */}
            <div
                className={`absolute inset-0 bg-black transition-opacity duration-300 ${
                    isVisible ? 'opacity-50' : 'opacity-0'
                }`}
                onClick={handleClose}
            />

            {/* Slide-in sheet: covers the map (right half) on desktop, full width on mobile */}
            <div
                className={`absolute top-0 right-0 h-full w-full md:w-1/2 bg-[var(--non-transparent-surface-color)] text-[var(--on-non-transparent-surface-color)] rounded-[8px] overflow-y-auto transition-transform duration-300 ease-out ${
                    isVisible ? 'translate-x-0' : 'translate-x-full'
                }`}>
                <ShowtimesFinderFiltersPanel
                    filters={filters}
                    setFilters={setFilters}
                    onClose={handleClose}
                    selectedDate={selectedDate}
                />
            </div>
        </div>
    );
};

export default FilterSheet;
